import { useState } from "react";
import { Button, Input, Modal } from "rizzui";
import useApi from "@/hooks/useApi";
import { IResponseData } from "@/utilities/types/requests";
import { IRoundRobinUser } from "@/utilities/types/RoundRobin";
import RoundRobinRepository from "@/utilities/repositories/RoundRobin";
import AddNewButton from "@/app/shared/add-new-button";
import UserRepository from "@/utilities/repositories/Users";
import { IUserDataResponse } from "@/utilities/types/Users";
import useApiStore from "@/hooks/useApiStore";
import { PiMagnifyingGlassBold } from "react-icons/pi";
import toast from "react-hot-toast";

export default function ButtonSearchExistingUser() {
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [isVisible, setVisible] = useState<boolean>(false);

  const { request: getUser, loading: loadingGetUser } = useApi<
    IResponseData<IRoundRobinUser>
  >({
    request: RoundRobinRepository.getUser,
    enableToast: false,
  });

  const { refetch: refetchUserTeamMember } = useApiStore<
    IResponseData<IUserDataResponse>
  >({
    request: UserRepository.getTeamUsers,
    key: "get-users-team-member",
    enableToast: false,
  });

  const { request: createUserSubAccount } = useApi<
    IResponseData<IRoundRobinUser>
  >({
    request: RoundRobinRepository.createUserSubAccount,
    enableToast: false,
  });

  const handleClose = () => {
    setVisible(false);
    setSearchQuery("");
  };

  const handleOpen = () => {
    setVisible(true);
  };

  const normalizePhone = (phone: string): string => {
    let cleaned = phone.replace(/[\s-]/g, "");

    if (cleaned.length > 8) {
      cleaned = cleaned.replace(/^(?:\+65|065|65)/, "");
    }

    return cleaned;
  };

  const handleConfirm = async () => {
    const toastId = toast.loading("Loading...");
    try {
      const userData = await getUser({
        search: normalizePhone(searchQuery),
      });
      if (userData?.data) {
        await createUserSubAccount({ data: { subUserId: userData.data.id } });
        await refetchUserTeamMember();
        toast.success("User added successfully", { id: toastId });
        handleClose();
        return;
      }

      throw new Error("User not found");
    } catch (error: any) {
      console.log("error", error?.message);
      toast.error(error?.msg || error?.error || "Get user failed", {
        id: toastId,
      });
    }
  };

  return (
    <>
      <AddNewButton
        onClick={handleOpen}
        className="w-auto whitespace-nowrap"
        label="Add Existing User"
      />
      <Modal isOpen={isVisible} onClose={handleClose} size="md">
        <div className="p-4">
          <h3 className="text-lg font-semibold mb-4">Add Existing User</h3>

          <div className="mb-4">
            <Input
              type="search"
              placeholder="Email or Phone number"
              value={searchQuery}
              onClear={() => setSearchQuery("")}
              onChange={(event) => setSearchQuery(event.target.value)}
              prefix={<PiMagnifyingGlassBold className="h-4 w-4" />}
              rounded="lg"
              clearable
              className="w-full @xl:ms-auto ml-auto @xl:w-auto  @4xl:w-[230px] @5xl:w-auto"
              disabled={loadingGetUser}
            />

            {/* <Select
              searchable
              clearable
              placeholder="Search by name, email..."
              searchPlaceHolder="Search by name"
              searchSuffix={loadingGetUser ? <Loader size="sm" /> : undefined}
              onSearchChange={debounce(setSearchQuery, 500)}
              disableDefaultFilter
              searchClassName="sticky"
              options={(responseGetUser?.data.items || []).map((user) => ({
                value: user.id,
                label: `${user.firstName} ${user.lastName} (${user.email})`,
                data: user,
              }))}
              value={selectedUser}
              onChange={handleSelectChange}
              onClear={handleClear}
            /> */}
          </div>

          <div className="w-full flex flex-row justify-between">
            <Button onClick={handleClose} isLoading={loadingGetUser}>
              Cancel
            </Button>
            <Button
              isLoading={loadingGetUser}
              onClick={handleConfirm}
              variant="outline"
              className="border-red-400 text-black hover:border-red-600"
            >
              OK
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}
